import { Component, OnInit, Inject, Input } from '@angular/core';

import {
  FormGroup,
  FormBuilder,
  Validators} from '@angular/forms';

import { IOptions } from '@ebb-v2/ebb-integration';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogWithdrawData {
  reasonoptions: IOptions[];
  reason: number;
  otherreason: string;
  title:string;
}
@Component({
    selector: 'ebb-portal-dialog-withdraw',
    templateUrl: './dialog-withdraw.component.html',
    styleUrl: './dialog-withdraw.component.scss',
    standalone: false
})
export class DialogWithdrawComponent implements OnInit {
  @Input('title') title = 'Withdraw Reason';
  public formwithdraw: FormGroup;
  public showother = false;
  public disablewithdrawSave = true;
  constructor(
    public dialogRef: MatDialogRef<DialogWithdrawComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogWithdrawData,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    if (this.data.title){
      this.title = this.data.title
    }
     this.initializeForm();
  }

  private initializeForm(): void {
    this.formwithdraw = this.fb.group({
      eventtype: ['', Validators.required],
      otherreason: ['']
    });
  }
  public onWithrawControlValidators(controlName: string): boolean {
    const retVal =
      this.formwithdraw.get(controlName).errors &&
      (this.formwithdraw.get(controlName).dirty ||
        this.formwithdraw.get(controlName).touched);

    return retVal;
  }
  public ebbWithdrawInputChange(event: any): void {
    this.disablewithdrawSave = false;
  }
  public onSave(): void {
    this.data.otherreason = this.formwithdraw.get('otherreason').value;
    this.data.reason = this.formwithdraw.get('eventtype').value;
    this.dialogRef.close(this.data);
  }
  public onClickCancel(): void {
    this.dialogRef.close();
  }
}
